@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand//entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.modal-body {
  padding: @space-16 @space-16 @space-32;
}

.modal-body-text {
  font-size: 14px;
  line-height: 18px;
}

.failed-vendor-invites-list {
  font-size: 14px;
  line-height: 21px;
  display: block;
  list-style-type: disc;
  padding: @space-8 @space-16 @space-16;
  .failed-vendor-bullet {
    display: list-item;
  }
}
